module.exports = __webpack_public_path__ + "img/bus-partner-img4.83213e8f.png";